import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CryptoService } from '@core/services/encryption/crypto.service';

@Component({
  selector: 'app-pin-entry',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './pin-entry.component.html',
  styleUrl: './pin-entry.component.scss',
})
export class PinEntryComponent {
  @ViewChild('pinInput') pinInput!: ElementRef<HTMLInputElement>;
  pin: string = '';
  loading: boolean = false;
  error: string | null = null;

  @Output() unlocked = new EventEmitter<void>();

  constructor(private cryptoService: CryptoService) {}

  async unlock() {
    if (this.pin.length !== 6) return;

    this.loading = true;
    this.error = null;

    try {
      const success = await this.cryptoService.unlockVault(this.pin);
      if (success) {
        this.unlocked.emit();
        this.pin = '';
      } else {
        this.error = 'Incorrect PIN';
        this.focusAndSelectInput();
      }
    } catch (e) {
      this.error = 'Failed to unlock';
      this.focusAndSelectInput();
    } finally {
      this.loading = false;
    }
  }

  private focusAndSelectInput() {
    setTimeout(() => {
      if (this.pinInput) {
        this.pinInput.nativeElement.focus();
        this.pinInput.nativeElement.select();
      }
    }, 100);
  }
}
